<template>
  <div class="search">
    <div class="input-group">
      <fa icon="search" />
      <input type="text" :placeholder="placeholder || 'Search'" @input="$emit('input', formattedSearchTerm)" v-model="searchTerm">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchAndAdd',
  props: {
    placeholder: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      searchTerm: ''
    }
  },
  computed: {
    formattedSearchTerm () {
      return this.searchTerm.trim().toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>

  .search {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .input-group {
      flex-grow: 1;
      position: relative;
      box-sizing: border-box;
      overflow: hidden;

      svg {
        left: 10px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        color: #C0C4CC;
      }

      input[type="text"] {
        width: 100%;
        padding-left: 35px;
        font-size: 14px;
        height: 40px;
        border: 0px;
        outline: none;
        background-color: transparent;
      }
    }

    .AddButton {
      margin-left: 20px;
      flex-shrink: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Search.vue